import { Box, HStack, Text, Image } from '@chakra-ui/react'
import StoreCoinSvg from '@images/store_coin.svg'
import { buildAssetUrlString } from '@!/Util'

export const LessCoinsBar = ({ lessCoins, recommendedCourseName }) => {
  return (
    <Box
      position="fixed"
      left={0}
      right={0}
      bottom={0}
      zIndex={100}
      bg="#F7F7F7"
      px={5}
      py={3}
      border="1px solid #DCDCE1"
      boxShadow="0 -2px 8px rgba(0,0,0,0.08)"
    >
      <HStack fontSize="2xs">
        <Text>不足コイン</Text>
        <HStack gap={1}>
          <Image w="20px" h="20px" src={buildAssetUrlString(StoreCoinSvg)} />
          <Text fontSize="lg" fontWeight="extrabold">
            {lessCoins.toLocaleString()}
          </Text>
        </HStack>
      </HStack>
      {recommendedCourseName && (
        <Text fontSize="2xs">
          不足分を無駄なくチャージ！
          <Text as="span" color="secondary.900" fontWeight="bold">
            【{recommendedCourseName}】
          </Text>
          が最適！
        </Text>
      )}
    </Box>
  )
}
